import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-7d84484a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "total-count" }
const _hoisted_2 = { class: "total-count-label" }
const _hoisted_3 = { class: "value" }
const _hoisted_4 = { class: "unit" }


export default /*#__PURE__*/_defineComponent({
  __name: 'pie-center',
  props: {
  title: {
    type: String,
    default: '总数'
  },
  value: {
    type: [String, Number],
    default: '',
  },
  unit: {
    type: String,
    default: '',
  },
  click: {
    type: [Function],
  }
},
  setup(__props) {

const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(__props.title), 1),
    _createElementVNode("div", {
      class: _normalizeClass(["total-count-value", { 'cm-link': __props.click, 'has-unit': __props.unit }]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (__props.click && __props.click()))
    }, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(__props.value), 1),
      _createElementVNode("span", _hoisted_4, _toDisplayString(__props.unit), 1)
    ], 2)
  ]))
}
}

})